export default {
    label: {
        alignment: 'Alignement & Listes',
        attachments: 'Pièces jointes',
        content: 'Contenu',
        insertion: 'Insertions',
        language: 'Langue',
        styling: 'Style de texte',
    },
    tools: {
        align: 'Aligner',
        alignLeft: 'Aligner à gauche',
        alignCenter: 'Aligner au centre',
        alignRight: 'Aligner à droite',
        attributes: 'Insérer des attributs',
        bold: 'Gras',
        list: 'Liste',
        bulletList: 'Liste à puces',
        blockQuote: 'Citation',
        erase: 'Effacer la mise en forme',
        italic: 'Italique',
        image: 'Insérer une image',
        isVideo: 'Visionner votre présentation vidéo',
        justify: 'Justifier',
        link: 'Insérer un lien',
        orderedList: 'Liste numérotée',
        strikethrough: 'Barré',
        textColor: 'Couleur du texte',
        textBackground: "Couleur d'arrière plan",
        underline: 'Souligner',
        video: 'Créer une présentation vidéo',
        insertVehicle: 'Insérer un véhicule',
    },
    characters: '{0} caractère | {0} caractères',
    dropImage: 'Glisser ou téléverser une image',
    editSignature: 'Modifier votre signature',
    hideHistory: "Masquer l'historique des courriels",
    imageUrl: 'Image URL',
    insert: 'Insérer',
    insertLink: 'Insérer un lien',
    link: 'Lien',
    originalCommunication: "Ajouter les informations d'origine du lead au courriel.",
    originalLeadEmail: 'Courriel lead original',
    showHistory: "Afficher l'historique des courriels",
    unlink: 'Retirer',
    uploadImage: 'Téléverser une image',
    validUrl: 'Veuillez entrer un URL valide',
};
